module.exports = __webpack_public_path__ + "media/images/odum_logo_small-87ca6921e0a36c7600c8ec73649e6a13.png";